export default {
	title: 'A history of supporting SMEs',
	description:
		'We assist small businesses to compete with big players.',
};
